import instance from "./axios.base";

const getOfficePrograms = async () => {
  const res = await instance.get("/officeprogram");
  return res.data;
};

export { getOfficePrograms };
